// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"fa0527ae","72":"073f73f7","477":"93c358c5","627":"4b512937","663":"b14ca6d0","667":"4d1e9651","777":"395ac711","803":"236de35a","820":"f7e50bc9"}[chunkId] + ".chunk.js";
};